import { useEffect } from 'react';

export default function SEO({title,description,canonical}:{title:string;description:string;canonical:string}) {
  useEffect(()=>{
    document.title = title;
    const set=(name:string,content:string,prop=false)=>{
      const selector=prop?`meta[property="${name}"]`:`meta[name="${name}"]`;
      let el=document.head.querySelector<HTMLMetaElement>(selector);
      if(!el){el=document.createElement('meta'); prop?el.setAttribute('property',name):el.setAttribute('name',name);document.head.appendChild(el)}
      el.content=content;
    };
    set('description',description); set('og:title',title,true); set('og:description',description,true); set('og:url',canonical,true); set('og:type','website',true); set('twitter:card','summary_large_image');
    let link=document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]'); if(!link){link=document.createElement('link');link.rel='canonical';document.head.appendChild(link)} link.href=canonical;
  },[title,description,canonical]);
  return null;
}
